import { Component } from '@angular/core';
import { GcHeaderComponent } from '../../shared/gc-header/gc-header.component';

@Component({
  selector: 'app-construction-documents-wrapper',
  imports: [GcHeaderComponent],
  templateUrl: './construction-documents-wrapper.component.html',
  styleUrl: './construction-documents-wrapper.component.scss',
})
export class ConstructionDocumentsWrapperComponent {}
